import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import cartImg from 'assets/img/cart.png';

import './style.scss';

const Cart = ({
  cart: {
    quantity,
    sum,
  },
}) => (
  <Link to="/cart" className="cart">
    <div className="cart__icon">
      <img src={cartImg} />
    </div>
    <div className="cart__description">
      <div className="cart__description__quantity">
        <span>Всего товаров: </span>
        <span className="cart__description__highlight" id="cart-quantity">{quantity}</span>
      </div>
      <div className="cart__description__sum">
        <span>На сумму: </span>
        <span className="cart__description__highlight" id="cart-sum">{sum}</span>
        <span className="cart__description__highlight"> руб.</span>
      </div>
    </div>
  </Link>
);

Cart.propTypes = {
  cart: PropTypes.shape({
    quantity: PropTypes.number.isRequired,
    sum: PropTypes.number.isRequired,
  }).isRequired,
};

export default Cart;



// WEBPACK FOOTER //
// ./src/components/ui/Header/Cart/index.js